import React, { useContext } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import TopNav from '../nav/TopNav';
import styled from 'styled-components';
import AddressContext from '../../context/address/addressContext';
import ShoppingContext from '../../context/shoping/shoppingContext';
import AddressCard from './addressComponents/AddressCard';

const StyledBurger = styled.div`
  input[type='email'],
  input[type='text'],
  select {
    padding: 3px 1rem;
    color: #fff;
    background: none;
    outline: none;
    border-radius: 0.8rem;
    box-shadow: none;
    border: 1px solid #fff;
  }
  input[type='email']:focus,
  input[type='text']:focus {
    // background: #000;
    outline: none;
    box-shadow: none;
  }
  .fa-trash:hover {
    cursor: pointer;
  }
  .bold-style {
    font-size: 1rem;
    font-weight: bold;
  }
`;

const ShippingAddressLogged = () => {
  const addressContext = useContext(AddressContext);
  const shoppingContext = useContext(ShoppingContext);

  const { userAddress } = addressContext;
  const { freeShipping } = shoppingContext;

  return (
    <Container className='LiveThrowdown p-0' fluid>
      <TopNav />
      <Container className='text-light'>
        <h2>Shipping Address</h2>
        <NavLink to='/apparel'>
          <u>Continue Shopping</u>
        </NavLink>

        <StyledBurger>
          <Row className='my-5  freeShipping_main'>
            <Col md={6} className=''>
              <div className='mb-3'>
                <NavLink to='/addnewAddress'>
                  <button className='btn border border-light  text-light'>
                    Add new address
                  </button>
                </NavLink>
              </div>
              {userAddress.map((address) => (
                <AddressCard key={address.id} address={address} />
              ))}
            </Col>

            <Col md={6} className=' pl-5'>
              <div className='shipping_cart_box p-4 '>
                <div className=' mb-4 text-capitalize '>
                  {freeShipping.map((shopping) => (
                    <Col key={shopping.id}>
                      <Row className='my-2'>
                        <Col className='d-flex p-0'>
                          <div className=' shipping-img'>{shopping.image}</div>
                          <div className='pl-4 shipping-img-heading'>
                            <div className=''>{shopping.heading}</div>

                            <div className='my-1'>
                              <p className='m-0 pl-1'>XS / Black</p>
                            </div>
                            <div className='my-1'>
                              <p className='m-0'>Qty: 2</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  ))}
                </div>
                <div className=' my-2'>
                  <div>Have a coupon?</div>
                  <div className='d-flex'>
                    <input
                      type='text'
                      className='border border-dark text-dark'
                    />
                    <button className='ml-3 btn border border-dark text-dark text-capitalize'>
                      apply
                    </button>
                  </div>
                </div>
                <div className='d-flex shipping_cart-bold my-2'>
                  <div>Shopping Cart</div>
                  <div className='ml-auto'>$ 20</div>
                </div>{' '}
                <div className='d-flex shipping_cart-bold'>
                  <div>Shipping</div>
                  <div className='ml-auto'>$ 10</div>
                </div>{' '}
                <div className='d-flex shipping_cart-bold  mt-3'>
                  <div>Total</div>
                  <div className='ml-auto text-strong'>$ 30</div>
                </div>
              </div>
            </Col>
          </Row>
        </StyledBurger>
      </Container>
    </Container>
  );
};
export default ShippingAddressLogged;
